import { useNavigate } from "react-router-dom";

import pages from "../../../constants/pages";
import { Chip, DataTable } from "../../../components";
import convertDate from "../../../utils/convertDate";

export default function Table({ actions }) {
  const navigate = useNavigate();

  const options = {
    onRowClick: (_, { dataIndex }) =>
      navigate(pages.utteranceDetails.route + actions[dataIndex]._id),
  };

  return <DataTable columns={columns} data={actions} options={options} />;
}

const columns = [
  {
    name: "action_type",
    label: "Action Type",
    options: {
      customBodyRender: (value) => {
        if (value) {
          return (
            <Chip
              background={
                value === "675125a61b23fa51e9fab558"
                  ? "#42a5f5"
                  : value === "675125cd1b23fa51e9fab559"
                  ? "#4caf50"
                  : "#ba68c8"
              }
              label={
                value === "675125a61b23fa51e9fab558"
                  ? "Send Message"
                  : value === "675125cd1b23fa51e9fab559"
                  ? "Update Lead"
                  : "Call URL"
              }
            />
          );
        }

        return "Not Available";
      },
    },
  },

  {
    name: "action_name",
    label: "Action Name",
    options: {
      customBodyRender: (value) => {
        return value ? value : "Not Available";
      },
    },
  },

  {
    name: "created_at",
    label: "Created At",
    options: {
      customBodyRender: (value) => {
        return value ? convertDate(value) : "Not Available";
      },
    },
  },
];
